<template>
    <main class="collections-page">
        <!-- Header -->
        <ThemeHeader />

        <!-- plp -->
        <div id="shopify-section-plp-header" class="shopify-section">
            <PlpProduct :PlpContent="sectionData.ourKitProducts" />
        </div>

        <!-- Compare kits -->
        <div id="shopify-section-plp-compare" class="shopify-section">
            <CompareKits title="Compare the kits" :CompareContent="sectionData.ourKitProducts" />
        </div>

        <!-- Footer -->
        <div id="shopify-section-footer" class="shopify-section">
            <ThemeFooter />

            <!-- Footer Sale Box -->
            <FooterSaleBox title="1% of sales go to The LA Fire Department Foundation." :img="saleLogo" />
        </div>

    </main>
</template>

<script>
    // Import component data. You can change the data in the store to reflect in all component
    import sectionData from '@/store/store';
    // import all components
    import ThemeHeader from "../components/common/ThemeHeader";
    import PlpProduct from "../components/sections/PlpProduct";
    import CompareKits from "../components/sections/CompareKits";
    import ThemeFooter from "../components/common/ThemeFooter";
    import FooterSaleBox from "../components/common/FooterSaleBox";
    export default {
        name: "Collections",
        components: {FooterSaleBox, ThemeFooter, CompareKits, PlpProduct, ThemeHeader},
        data() {
            return {
                sectionData,
                saleLogo: require('@/assets/images/lafd-logo.png')
            }
        }
    }
</script>

<style scoped>

</style>